"use client";

import { Play, Clock, BookOpen } from "lucide-react";

export default function NewCard({ course }) {
  return (
    <button
      onClick={() => (window.location.href = course.link)}
      className="w-full max-w-sm bg-gradient-to-br from-gray-900 via-gray-800 to-black rounded-2xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 text-left"
    >
      {course.isFeatured && (
        <div className="relative p-4 pb-0">
          <div className="absolute top-0 left-0 bg-gradient-to-r from-[#149FD4] to-[#4D50E6] text-white text-xs font-bold px-4 py-2 transform -rotate-12 -translate-x-2 -translate-y-2 shadow-lg">
            FEATURED
          </div>
        </div>
      )}

      {/* Hero Image Section */}
      <div
        className={`relative mx-4 ${
          course.isFeatured ? "mt-8" : "mt-4"
        } rounded-xl overflow-hidden shadow-lg aspect-[16/9]`}
      >
        <img
          src={course.heroImage || "/placeholder.svg"}
          alt={`${course.title} hero image`}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content Section */}
      <div className="p-6">
        {/* Title and Badges */}
        <div className="mb-6">
          <h1 className="text-white text-lg md:text-xl font-bold mb-3 leading-tight">
            {course.title}
          </h1>
          {course.badges.length > 0 && (
            <div className="flex gap-2 flex-wrap">
              {course.badges.map((badge, index) => (
                <div
                  key={index}
                  className="inline-flex items-center px-3 py-1 bg-gray-900 border border-gray-600 text-white text-sm font-medium rounded-md shadow-xl shadow-black/50 transform hover:translate-y-[-1px] transition-transform"
                >
                  {badge}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="space-y-4 mb-8">
          <div className="flex items-center gap-3 text-gray-300">
            <Clock className="w-5 h-5 text-blue-400 flex-shrink-0" />
            <span className="text-sm">{course.duration}</span>
          </div>
          {course?.lessons && (
            <div className="flex items-center gap-3 text-gray-300">
              <BookOpen className="w-5 h-5 text-blue-400 flex-shrink-0" />
              <span className="text-sm">{course.lessons} module</span>
            </div>
          )}
          <div className="flex items-center gap-3 text-gray-300">
            <img
              src={course.instructor.image || "/placeholder.svg"}
              alt={course.instructor.name}
              className="w-5 h-5 rounded-full object-cover flex-shrink-0"
            />
            <span className="text-sm">{course.instructor.name}</span>
          </div>
        </div>

        <div className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-2 shadow-lg">
          <span className="text-2xl">{course.price.current}</span>
          {course.price.original && (
            <span className="text-sm line-through text-blue-200">
              {course.price.original}
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
